import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import { Icon } from 'panamera-react-ui';
var css = {
  "priceWidget": "oalp-2HGjw",
  "bgImage": "oalp-2ZyJJ",
  "backIcon": "oalp-1rmBU",
  "container": "oalp-176Ps",
  "desktop": "oalp-3MN5F",
  "cta": "oalp-2DE1y",
  "hoverClass": "oalp-mljlE"
};
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import { EVALUATION_STATES, EVALUATION_STATES_TRACKING, FLOW_TYPES } from "../../Constants/evaluation";
import classNames from 'classnames';
import CTA from "../../Components/CTA/CTA";
import DependencyManager from "../../DependencyManager";
import UserSession from "../../Utils/UserSession";
import { trackingHelper } from "../../Helpers/trackingHelper";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
import useErrorCookie from "../../CustomHooks/useErrorCookie/useErrorCookie";
import withConfig from "./../../ComponentDependency/withConfig";
import useValuationResult from "../BookAnAppointment/useValuationResults";
export var ValuationError = function ValuationError(_ref) {
  var _ref$data = _ref.data,
    title = _ref$data.title,
    subText = _ref$data.subText,
    image = _ref$data.image,
    backgroundImage = _ref$data.backgroundImage,
    cta = _ref$data.cta,
    metadata = _ref.metadata,
    handleIconClick = _ref.handleIconClick,
    track = _ref.track,
    locationId = _ref.locationId,
    origin = _ref.origin,
    widgetName = _ref.name,
    landingURLSearch = _ref.landingURLSearch,
    params = _ref.params,
    config = _ref.config;
  var _ref2 = metadata || {},
    style = _ref2.style,
    showBackIcon = _ref2.showBackIcon;
  var _useState = useState(subText && subText.text || ''),
    _useState2 = _slicedToArray(_useState, 2),
    finalSubText = _useState2[0],
    setSubText = _useState2[1];
  var ctaMetaData = null;
  if (metadata && (metadata.trackingInfo || metadata.resultsetType)) {
    ctaMetaData = {
      trackingInfo: metadata.trackingInfo,
      resultsetType: metadata.resultsetType
    };
  }
  var _useValuationResult = useValuationResult(),
    buyableMaxPrice = _useValuationResult.buyableMaxPrice;
  useEffect(function () {
    if (subText && subText.text && subText.text.indexOf('{dynamicLimit}') > 0 && buyableMaxPrice) {
      var newSubText = subText.text;
      var finalStr = newSubText.replace('{dynamicLimit}', buyableMaxPrice.toString());
      setSubText(finalStr);
    }
  }, [subText, buyableMaxPrice]);
  useEffect(function () {
    onTrack(TRACKING_EVENTS.VALUATION_PAGE_OPEN);
  }, []);
  useErrorCookie({
    widgetName: widgetName
  });
  var PanameraConstants = DependencyManager.getDependency('constants');
  var backIconClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var evalState = UserSession.getUserEvaluationState();
    var configValues = config.get();
    if (evalState === EVALUATION_STATES.CALLBACK_REQUESTED) {
      if (handleIconClick) {
        handleIconClick(EVALUATION_STATES.CALLBACK_REQUESTED);
        trackingHelper({
          eventName: TRACKING_EVENTS.VALUATION_EDIT_CAR_DETAILS_ERROR_CALLBACK,
          track: track,
          locationId: locationId,
          origin: origin,
          select_from: EVALUATION_STATES_TRACKING.CALLBACK_COMPLETE,
          landingURLSearch: landingURLSearch,
          params: params,
          config: configValues
        });
      }
    } else {
      UserSession.deleteLastSelectionOption();
      if (handleIconClick) {
        handleIconClick(EVALUATION_STATES.VALUATION_ERROR);
        trackingHelper({
          eventName: TRACKING_EVENTS.VALUATION_EDIT_CAR_DETAILS_ERROR,
          track: track,
          locationId: locationId,
          origin: origin,
          select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
          landingURLSearch: landingURLSearch,
          params: params,
          config: configValues
        });
      }
    }
  }, [handleIconClick, landingURLSearch, locationId, origin, track, params, config]);
  var onTrack = useCallback(function (eventName) {
    var configValues = config.get();
    trackingHelper({
      eventName: eventName,
      track: track,
      locationId: locationId,
      origin: origin,
      select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
      landingURLSearch: landingURLSearch,
      params: params,
      config: configValues
    });
  }, [track, locationId, origin, landingURLSearch, params, config]);
  return /*#__PURE__*/React.createElement("div", {
    className: css.priceWidget,
    style: style
  }, backgroundImage && /*#__PURE__*/React.createElement(ImageWrapper, {
    image: backgroundImage,
    className: css.bgImage
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(css.container, css[PanameraConstants.platform])
  }, showBackIcon ? /*#__PURE__*/React.createElement("span", {
    className: css.backIcon,
    onClick: backIconClick
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrowLeft",
    size: 24
  })) : null, /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image
  }), title && /*#__PURE__*/React.createElement("p", {
    className: css.brandText,
    style: title.style
  }, title.text), subText && /*#__PURE__*/React.createElement("p", {
    className: css.subText,
    style: subText.style,
    dangerouslySetInnerHTML: {
      __html: finalSubText
    }
  }), cta && cta.buttons && /*#__PURE__*/React.createElement("div", {
    className: css.cta,
    style: cta.style
  }, cta.buttons.map(function (button, idx) {
    return /*#__PURE__*/React.createElement(CTA, {
      key: "widget_".concat(widgetName, "_cta_").concat(idx),
      button: button,
      widgetKey: widgetName,
      track: track,
      locationId: locationId,
      "data-aut-id": widgetName,
      metadata: ctaMetaData,
      customClass: css.hoverClass,
      onTrack: onTrack,
      select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
      flow_type: FLOW_TYPES.NO_DRAFT
    });
  }))));
};
export default withConfig(ValuationError);